

import React, { useEffect, useState } from "react";
import { PageLayout } from "containers";
import "./App.css";
import RouteComponent from "routes/RouteComponent";
import "antd/dist/antd.css";
import "react-table/react-table.css";
import { Location } from "@reach/router";
import { ErrorBoundary } from "components";
import { ThemeProvider, useTheme } from "context/themeContext";
import { extractOperatorName } from "constants/config";
import { config } from "constants/config";
import { handleError } from "appRedux/actions/Common";
import Loader from "components/Loader";
import api from "appRedux/api";
import { countriesProp } from "utils/countries";

const AppWithTheme = () => {
  const { setColorTheme, setLogoUrl, setWhiteLabelName,setCanReserve,setCountryProperties } = useTheme();
  const [operatorNotFound, setOperatorNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

 

  useEffect(() => {
    const operator = extractOperatorName(window.location.href, "after");
  
    if (!operator) {
      setOperatorNotFound(true);
      setIsLoading(false);
      return;
    }
  
    const fetchTheme = async () => {
      try {
        const response = await api.get(
          `/operator/whitelabel/${operator}`,
          {},
          config.baseUrl
        );
  
        const result = response?.data;
  
        if (!result?.data) {
          setOperatorNotFound(true);
          return;
        }
  
        const { colour, logoURL, description,
          canReserveSeat,country } = result.data;
      
  
        // Save into React Context only
        setColorTheme(colour);
        setLogoUrl(logoURL);
        setWhiteLabelName(description);
        setCanReserve(
          canReserveSeat)
          const countryCode = country.countryCode
       
        const countryProperties = countriesProp.find((x)=> x.country_code == countryCode)
        setCountryProperties(countryProperties)
       
  
      } catch (err) {
        handleError("Operator information fetch failed:", err?.message);
        console.error("Theme fetch failed:", err?.message);
        setOperatorNotFound(true);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchTheme();
  }, [setColorTheme, setLogoUrl, setWhiteLabelName,setCountryProperties]);
  

  if (isLoading) {
    return <Loader />;
  }

  if (operatorNotFound) {
    return (
      <div className="main-section">
        <h1 className="form-header-2 ">Something went wrong.</h1>
        <br />
        <p>Kindly confirm the url is correct. if it is, kindly notify our team and check back later, Thanks</p>
      </div>
    )
  }

  return (
    <Location>
      {({ location }) => (
        <div className="App">
          <ErrorBoundary>
            <PageLayout location={location}>
              <RouteComponent location={location} />
            </PageLayout>
          </ErrorBoundary>
        </div>
      )}
    </Location>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AppWithTheme />
    </ThemeProvider>
  );
}

export default App;
